import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $data.show = true;
    })
  }, [_renderSlot(_ctx.$slots, "default"), $data.show ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: "#dropdown"
  }, [_createElementVNode("div", null, [_createElementVNode("div", {
    style: {
      "position": "fixed",
      "top": "0",
      "right": "0",
      "left": "0",
      "bottom": "0",
      "z-index": "99998",
      "background": "black",
      "opacity": "0.2"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.show = false;
    })
  }), _createElementVNode("div", {
    ref: "dropdown",
    style: {
      "position": "absolute",
      "z-index": "99999"
    },
    onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return $data.show = !$props.autoClose;
    }, ["stop"]))
  }, [_renderSlot(_ctx.$slots, "dropdown")], 512)])])) : _createCommentVNode("", true)]);
}